import { isNull } from 'lodash'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { ITechnicianScorecard } from '../../../../app/entities/TechnicianScorecard'
import PrimaryDropdown from '../../global/components/dropdowns/PrimaryDropdown'
import LocationDropDown from '../../global/components/location-drop-down/LocationDropDown'
import MainPageWrapper from '../../global/components/MainPageWrapper'
import { MONTH } from '../../global/constants/date'
import { IS_ENV_PROD } from '../../global/constants/env'
import TechnicianScorecardModal from '../modal/TechnicianScorecardModal'
import TechnicianScorecardsTable from '../table/TechnicianScorecardsTable'
import styles from './styles.module.css'

const FIRST_YEAR = IS_ENV_PROD ? 2025 : 2020 //so we can test
export interface ILocationFilters {
  locationObjectId: string
  setLocationObjectId: Dispatch<SetStateAction<string>>
}
function getCurrentQuarter() {
  const currentDate = new Date()
  const currentMonth = currentDate.getMonth()
  if (currentMonth >= 0 && currentMonth <= 2) {
    return 1
  } else if (currentMonth >= 3 && currentMonth <= 5) {
    return 2
  } else if (currentMonth >= 6 && currentMonth <= 8) {
    return 3
  } else {
    return 4
  }
}

function getMonthsForQuarter(quarter: number) {
  switch (quarter) {
    case 1:
      return [MONTH[0], MONTH[1], MONTH[2]]
    case 2:
      return [MONTH[3], MONTH[4], MONTH[5]]
    case 3:
      return [MONTH[6], MONTH[7], MONTH[8]]
    case 4:
      return [MONTH[9], MONTH[10], MONTH[11]]
    default:
      return []
  }
}

function TechnicianScorecardMain() {
  const currentDate = new Date()
  const [locationObjectId, setLocationObjectId] = useState<string>('')
  const [isOpen, setIsOpen] = useState(false)
  const [technicianScorecard, setTechnicianScorecard] =
    useState<ITechnicianScorecard | null>(null)
  const [month, setMonth] = useState<(typeof MONTH)[number] | null>(
    MONTH[currentDate.getMonth()],
  )
  const [quarter, setQuarter] = useState<string | null>(null)
  const [year, setYear] = useState<number | null>(null)
  const [queryMonths, setQueryMonths] = useState([
    MONTH[currentDate.getMonth()],
  ])
  const [queryYear, setQueryYear] = useState(currentDate.getFullYear())

  const listOfYears = Array.from(
    { length: currentDate.getFullYear() - FIRST_YEAR + 1 },
    (_, i) => FIRST_YEAR + i,
  )
  const listOfQuarters: string[] = []
  listOfYears.forEach((year) => {
    for (let i = 1; i <= 4; i++) {
      if (year < currentDate.getFullYear() || i <= getCurrentQuarter()) {
        listOfQuarters.push(`${year} Q${i}`)
      }
    }
  })
  const listOfMonths = [
    ...MONTH.slice(currentDate.getMonth() + 1),
    ...MONTH.slice(0, currentDate.getMonth() + 1),
  ]

  useEffect(() => {
    if (isNull(month)) return
    setQuarter(null)
    setYear(null)

    const currentYear = currentDate.getFullYear()
    const indexOfSelectedMonth = MONTH.indexOf(month)
    if (indexOfSelectedMonth > currentDate.getMonth()) {
      setQueryYear(currentYear - 1)
    } else {
      setQueryYear(currentYear)
    }
    setQueryMonths([month])
  }, [month])

  useEffect(() => {
    if (isNull(quarter)) return
    setMonth(null)
    setYear(null)

    const [yearString, quarterString] = quarter.split(' Q')
    const monthsForQuarter = getMonthsForQuarter(parseInt(quarterString))
    setQueryMonths(monthsForQuarter)
    setQueryYear(parseInt(yearString))
  }, [quarter])

  useEffect(() => {
    if (isNull(year)) return
    setMonth(null)
    setQuarter(null)

    setQueryMonths([...MONTH])
    setQueryYear(year)
  }, [year])

  return (
    <MainPageWrapper
      titleFields={
        <div className={styles.headerContainer}>
          <LocationDropDown
            onLocationChange={(val: string) => {
              setLocationObjectId(val)
            }}
          />
          <div className={styles.headerParantheses}>{'('}</div>
          <PrimaryDropdown
            label='Month'
            items={listOfMonths.reverse().map((m) => ({ key: m, value: m }))}
            defaultValue={month || ''}
            onChange={(val) => setMonth(val as (typeof MONTH)[number])}
            disabled={false}
          />
          <div className={styles.headerAndOrText}>or</div>
          <PrimaryDropdown
            label='Quarter'
            items={listOfQuarters.reverse().map((q) => ({ key: q, value: q }))}
            defaultValue={quarter || ''}
            onChange={setQuarter}
            disabled={false}
          />
          <div className={styles.headerAndOrText}>or</div>
          <PrimaryDropdown
            label='Full Year'
            items={listOfYears.reverse().map((y) => ({ key: String(y), value: String(y) }))}
            defaultValue={year ? String(year) : ''}
            onChange={(val) => setYear(val ? Number(val) : null)}
            disabled={false}
          />
          <div className={styles.headerParantheses}>{')'}</div>
        </div>
      }
    >
      <TechnicianScorecardModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        technicianScorecard={technicianScorecard}
        setTechnicianScorecard={setTechnicianScorecard}
      />
      <TechnicianScorecardsTable
        locationFilters={{ locationObjectId, setLocationObjectId }}
        setIsOpen={setIsOpen}
        setTechnicianScorecard={setTechnicianScorecard}
        months={queryMonths}
        year={queryYear}
      />
    </MainPageWrapper>
  )
}

export default TechnicianScorecardMain
